@if (loading()) {
  <div class="loader">
    <saf-progress-text>Loading</saf-progress-text>
  </div>
}
